import axios from 'axios';

import authService from './authService';
import mainVersionOneService from './mainVersionOneService';

const CancelToken = axios.CancelToken;

let cancel;

export function userRecords(portId, data) {
    if (cancel !== undefined) {
        cancel();
    }
    const formatFilter = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${v}:${d[v]}`;
            })
            .join(',');
    };
    const formatSearch = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${d[v]}`;
            })
            .join(',');
    };

    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;
                break;
            case 'limit':
                parameters = `${parameters}&limit=${value}`;
                break;
            case 'filter':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&filter=${formatFilter(value)}`;
                }
                break;
            case 'search':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&search=${formatSearch(value)}`;
                }
                break;
        }
    }

    return mainVersionOneService
        .get(`manageUsers/${portId}/records?rand=${new Date().getTime()}${parameters}`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userDelete(portId: number, id: number) {
    return mainVersionOneService
        .delete(`manageUsers/${portId}/${id}/delete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userRecord(portId: number, id: number) {
    return mainVersionOneService
        .get(`manageUsers/${portId}/${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userPortRecord(portId: number, id: number) {
    return mainVersionOneService
        .get(`manageUsers/${portId}/userPort/${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userUpdate(portId: number, id: number, data: object) {
    return mainVersionOneService
        .put(`manageUsers/${portId}/${id}/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userPortDelete(portId: number, id: number) {
    return mainVersionOneService
        .delete(`manageUsers/${portId}/userPort/${id}/userPortDelete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userPortModify(portId: number, id: number, data: object) {
    return mainVersionOneService
        .post(`manageUsers/${portId}/userPort/${id}/userPortModify`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userKillToken(portId: number, id: number) {
    return mainVersionOneService
        .get(`manageUsers/${portId}/${id}/killToken`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userGetToken(portId: number, id: number) {
    return mainVersionOneService
        .get(`manageUsers/${portId}/${id}/getToken`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function userCreate(portId: number, data: object) {
    return mainVersionOneService
        .post(`manageUsers/${portId}/create`, { port_id: portId, ...data })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function setToken(data: object) {
    return authService
        .post('/setToken', data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function getIdToken() {
    return authService
        .get('/getIdToken')
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
